import request from "@/utils/request";

export function getGoodsOrder(data) {
  return request({
    url: "/user/goodsOrder/page",
    method: "get",
    params: data
  });
}

export function getGoodsOrderUpdate(id) {
  return request({ url: `/user/goodsOrder/getOne/${id}`, method: "get" });
}

export function goodsOrderReceipt(orderNo) {
  return request({
    url: `/user/goodsOrder/${orderNo}/receipt`,
    method: "get"
  });
}
